module.exports = __webpack_public_path__ + "static/media/WhenWordsHavePower.62243688.jpg";